import { render, staticRenderFns } from "./setting_user_notifications.vue?vue&type=template&id=40327829&scoped=true"
import script from "./setting_user_notifications.vue?vue&type=script&lang=ts"
export * from "./setting_user_notifications.vue?vue&type=script&lang=ts"
import style0 from "./setting_user_notifications.vue?vue&type=style&index=0&id=40327829&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40327829",
  null
  
)

export default component.exports